<template>
    <div>
        <Dj />
        <v-row class="justify-center">
            <v-col cols="10" md="6">
                <v-btn block color="black" dark to="/">
                    home
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="justify-center text-center" style="margin-top:0px;">
            <v-col cols="10" md="6">
                <b><v-icon style="font-size:250px;" :color="icon_color">mdi-infinity</v-icon></b>
            </v-col>
        </v-row>
        <v-row class="justify-center text-center" style="display:none;">
            <v-col cols="10" md="6">
                <audio controls autoplay>
                    <source :src="'../audios/'+init_song" type="audio/ogg">
                    Your browser does not support the audio element.
                </audio> 
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Dj from "../components/Dj";
import data_ from '../plugins/data.json'


export default {
    name: 'Free',
    created: function () {
        this.song()
        this.color()
    },
    components: {
        Dj
    },
    data: () => ({
        init_song: '',
        songs_list: data_['songs'],
        icon_color: ''
    }),
    methods: {
        song: function(){
            const random = Math.floor(Math.random() * this.songs_list.length);
            this.init_song = this.songs_list[random]
        },
        color: function(){
            const random = Math.floor(Math.random() * data_['colors'].length);
            this.icon_color = data_['colors'][random]
        }
    }
}
</script>

<style scoped>
</style>
